import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LinkComponent } from './link.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [LinkComponent],
  exports: [LinkComponent],
})
export class LinkModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/th/webapp/src/app/@shared/ui/link/link.module.ts